// Shared verified badge + trust label for the Social Accounts section
// (EPD-10118). One component so the badge and typography stay consistent
// between the metrics heading ("Last updated · Today") and the audience
// demographics heading ("Last 30 Days"). Themed via the renderer's --pf-* vars.

import type { ReactNode } from "react";

/** The small accent trust mark (a checkmark in an accent circle). */
export function VerifiedBadge() {
  return (
    <span
      role="img"
      aria-label="Authenticated account"
      title="Authenticated account"
      className="inline-flex shrink-0 items-center justify-center rounded-full"
      style={{
        width: 14,
        height: 14,
        background: "var(--pf-accent)",
        color: "var(--pf-accent-text)",
      }}
    >
      <svg
        width="9"
        height="9"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}

/**
 * The verified badge followed by a muted label. Sits opposite a section heading
 * and wraps below it rather than truncating at narrow widths.
 */
export function VerifiedLabel({ children }: { children: ReactNode }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[12px]"
      style={{ color: "var(--pf-muted)" }}
    >
      <VerifiedBadge />
      {children}
    </span>
  );
}
